import React, { Component } from 'react';
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Spin,
  Switch
} from 'antd';
import PropTypes from 'prop-types';
import _ from 'lodash';

import './EditUserForm.css';

class RegistrationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDirty: false
    };
  }

  handleRegister = (event) => {
    event.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        // this.props.form.resetFields()
        this.props.onCreate(values, this.props.form);
      }
    });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback('The two passwords you entered are incompatible!');
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  onCancel = () => {
    const form = this.props.form;
    form.resetFields();
    this.props.onCancel();
  };

  preparePermissionTreeData = () => {
    let permissionData = [
      {
        title: 'User type',
        key: 'permissions',
        children: []
      }
    ];

    _.forEach(this.props.permissions, (permission) => {
      permissionData[0].children.push({
        title: permission.description,
        key: permission.id
      });
    });

    return permissionData;
  };

  preparePermissionsRadio = () => {
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
      marginLeft: '30px'
    };

    let permissionComponent = [];
    _.forEach(this.props.permissions, (permission) => {
      permissionComponent.push(
        <Radio
          style={radioStyle}
          value={permission.id}
          key={`radio_index_${permission.id}`}
        >
          {permission[this.props.permissionKey]}
        </Radio>
      );
    });

    return permissionComponent;
  };

  render() {
    const { loaderIsVisible } = this.props;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const permissionData = this.preparePermissionTreeData();
    const formItemLayout = {
      labelCol: { span: 10, className: 'label-container' },
      wrapperCol: { span: 14 }
    };
    const customFormItemLayout = {
      labelCol: { span: 14, className: 'label-container' },
      wrapperCol: { span: 10 }
    };

    return (
      <Modal
        title='Create user'
        // okText="Create"
        // cancelText="Cancel"
        visible={this.props.isVisible}
        // onOk={this.handleRegister}
        onCancel={this.onCancel}
        keyboard={false}
        maskClosable={false}
        width={620}
        footer={[
          <Button key='back' loading={loaderIsVisible} onClick={this.onCancel}>
            Cancel
          </Button>,
          <Button
            key='submit'
            type='primary'
            loading={loaderIsVisible}
            onClick={this.handleRegister}
          >
            Save
          </Button>
        ]}
      >
        <Spin size='large' spinning={loaderIsVisible}>
          <Row className='userEditForm'>
            <Form layout='vertical' prefixCls='add_new_user_'>
              <Col xs={24}>
                <Form.Item label='User name'>
                  {getFieldDecorator('name', {
                    rules: [
                      {
                        required: true,
                        message: 'This field cannot be empty.'
                      }
                    ]
                  })(<Input autoComplete='off' />)}
                </Form.Item>
              </Col>
              <Col xs={24}>
                <Form.Item label='Email'>
                  {getFieldDecorator('email', {
                    rules: [
                      {
                        required: true,
                        message: 'This field cannot be empty.'
                      },
                      {
                        type: 'email',
                        message: 'You have entered an invalid email address.!'
                      }
                    ]
                  })(<Input autoComplete='off' />)}
                </Form.Item>
              </Col>
              <Col xs={24}>
                <Form.Item
                  label={`Account ${
                    getFieldValue('active') ? 'active' : 'disabled'
                  }`}
                  {...formItemLayout}
                >
                  {getFieldDecorator('active', {
                    initialValue: true,
                    valuePropName: 'checked'
                  })(<Switch />)}
                </Form.Item>
              </Col>

              <Col xs={8}>
                <Form.Item label='User type'>
                  {getFieldDecorator('role', {
                    rules: [
                      {
                        required: true,
                        message: 'This field cannot be empty.'
                      }
                    ]
                  })(
                    <Radio.Group>
                      {this.preparePermissionsRadio(permissionData)}
                    </Radio.Group>
                  )}
                </Form.Item>
              </Col>
              <Col xs={16}>
                <Col xs={24}>
                  <div className='custom-label'>
                    <span>Pages permission:</span>
                  </div>
                </Col>
                <Col xs={12}>
                  <Form.Item label='Images' {...customFormItemLayout}>
                    {getFieldDecorator('imagePermission', {
                      valuePropName: 'checked',
                      initialValue: false
                    })(<Switch />)}
                  </Form.Item>
                  <Form.Item label='Quality' {...customFormItemLayout}>
                    {getFieldDecorator('qualityControlPermission', {
                      valuePropName: 'checked',
                      initialValue: false
                    })(<Switch />)}
                  </Form.Item>
                </Col>
                <Col xs={12}>
                  <Form.Item label='Domains' {...customFormItemLayout}>
                    {getFieldDecorator('domainPermission', {
                      valuePropName: 'checked',
                      initialValue: false
                    })(<Switch />)}
                  </Form.Item>
                  <Form.Item label='Review' {...customFormItemLayout}>
                    {getFieldDecorator('reviewPermission', {
                      valuePropName: 'checked',
                      initialValue: false
                    })(<Switch />)}
                  </Form.Item>
                </Col>
                <Col xs={12}>
                  <Form.Item label='Search' {...customFormItemLayout}>
                    {getFieldDecorator('tablePermission', {
                      valuePropName: 'checked',
                      initialValue: false
                    })(<Switch />)}
                  </Form.Item>
                </Col>
                <Col xs={12}>
                  <Form.Item label='Import' {...customFormItemLayout}>
                    {getFieldDecorator('importPermission', {
                      valuePropName: 'checked',
                      initialValue: false
                    })(<Switch />)}
                  </Form.Item>
                </Col>
                <Col xs={12}>
                  <Form.Item label='Image Upload' {...customFormItemLayout}>
                    {getFieldDecorator('imageUploadPermission', {
                      valuePropName: 'checked',
                      initialValue: false
                    })(<Switch />)}
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item label='Image Management' {...customFormItemLayout}>
                    {getFieldDecorator('imageManagementPermission', {
                      valuePropName: 'checked',
                      initialValue: false
                    })(<Switch />)}
                  </Form.Item>
                </Col>
              </Col>
              <Col xs={24}>
                <Form.Item label='Password'>
                  {getFieldDecorator('password', {
                    rules: [
                      {
                        required: true,
                        message: 'This field cannot be empty.'
                      },
                      {
                        min: 8,
                        message: 'Must be minimum 8 characters.'
                      },
                      {
                        validator: this.validateToNextPassword
                      }
                    ]
                  })(<Input type='password' autoComplete='off' />)}
                </Form.Item>
              </Col>
              <Col xs={24}>
                <Form.Item label='Password confirmation'>
                  {getFieldDecorator('confirm', {
                    rules: [
                      {
                        required: true,
                        message: 'This field cannot be empty.'
                      },
                      {
                        validator: this.compareToFirstPassword
                      }
                    ]
                  })(
                    <Input
                      type='password'
                      onBlur={this.handleConfirmBlur}
                      autoComplete='off'
                    />
                  )}
                </Form.Item>
              </Col>
            </Form>
          </Row>
        </Spin>
      </Modal>
    );
  }
}

RegistrationForm.propTypes = {
  isVisible: PropTypes.bool,
  loaderIsVisible: PropTypes.bool,
  onCancel: PropTypes.func,
  onCreate: PropTypes.func,
  permissions: PropTypes.array
};

export default Form.create({ name: 'LoginForm' })(RegistrationForm);
